<!--
ホーム画面
URL：/
表示条件：ログイン済みであること
-->

<template>
  <div>
    <header-title :showAccountInfo="true"></header-title>

    <v-tabs
      v-model="tabIndex"
      centered
      background-color="grey darken-1"
      color="white"
      dark
      center-active
      active-class="tab-active"
    >
      <v-tabs-slider color="transparent"></v-tabs-slider>
      <v-tab
        class="tab-item"
        style="width: 0px; padding: 0px; min-width: 0px"
      />
      <v-tab
        class="tab-item"
        :style="{ width: item.label === '広島県からのお知らせ' ? 'auto' : '200px' }"
        style="font-size: 16pt"
        v-for="item in tabItems"
        :key="item.key"
        @click.stop="item.callback"
      >
        {{ item.label }}
        <span v-if="item.notice" class="notice">！</span>
      </v-tab>
    </v-tabs>

    <v-row
      v-if="showRecordMenu"
      justify="center"
      style="text-align: center; margin-top: 10px"
    >
      <v-col
        cols="auto"
        style="display: flex; align-items: center; padding: 10px"
      >
        <p style="font-size: 20px; margin: 0px">作業登録</p>
      </v-col>
      <v-col cols="auto" style="padding: 10px">
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          @click="worklog"
          >作業記録</v-btn
        >
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          @click="unloading"
          >水揚げ</v-btn
        >
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          @click="shipping"
          >加工・出荷</v-btn
        >
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          @click="seaWater"
          >使用海水</v-btn
        >
      </v-col>
    </v-row>

    <v-row
      v-if="showGraphMenu"
      justify="center"
      style="text-align: center; margin-top: 10px"
    >
      <v-col cols="auto" style="padding: 10px">
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          :outlined="!this.$router.currentRoute.path.startsWith('/graph/product')"
          @click="graph"
          >生産情報</v-btn
        >
        <v-btn
          color="primary"
          style="font-size: 24px"
          class="ma-2"
          width="200"
          height="50"
          :outlined="!this.$router.currentRoute.path.startsWith('/graph/umilog')"
          @click="umilogGraph"
          >うみログ</v-btn
        >
        <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            :outlined="!this.$router.currentRoute.path.startsWith('/deviceMap')"
            @click="deviceMap"
        >現在水温</v-btn
        >
        <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            :outlined="!this.$router.currentRoute.path.startsWith('/externalLink')"
            @click="externalLink"
        >外部リンク</v-btn
        >
      </v-col>
    </v-row>

    <router-view></router-view>
  </div>
</template>

<script>
import HeaderTitle from "../components/frame/header-title.vue";
export default {
  components: {
    "header-title": HeaderTitle,
  },
  data() {
    return {
      tabIndex: 0,
      showRecordMenu: false,
      showGraphMenu: false,
      showPrefInformationMenu: false,
      showPredictionTool: false,
    };
  },
  mounted() {
    let items = this.getTabItems();
    this.tabIndex = this.getTabIndexFromCurrentURL(items);
    this.showRecordMenu = this.getShowRecordMenu();
    this.showGraphMenu = this.getShowGraphMenu();

      // タブフォーカス制御
      if (this.showRecordMenu) this.tabIndex = 3;
      if (this.showGraphMenu) this.tabIndex = 4;
  },
  computed: {
    tabItems() {
      return this.getTabItems();
    },
  },
  watch: {
    $route() {
      this.tabIndex = this.getTabIndexFromCurrentURL(this.tabItems);
      this.showRecordMenu = this.getShowRecordMenu();
      this.showGraphMenu = this.getShowGraphMenu();

      // タブフォーカス制御
      if (this.showRecordMenu) this.tabIndex = 3;
      if (this.showGraphMenu) this.tabIndex = 4;
    },
  },
  methods: {
    getTabIndexFromCurrentURL(tabItems) {
      let tabIndex = 0;
      tabItems.forEach((item, index) => {
        if (this.$router.currentRoute.path.startsWith(item.path)) {
          tabIndex = index + 1;
        }
      });
      return tabIndex;
    },
    getTabItems() {
      /**
       * ホーム上部のタブに項目を追加する場合は、ここに追加する
       */
      let items = [];

      items.push({
        path: "/prefinformation",
        label: "広島県からのお知らせ",
        key: "4",
        notice: this.$store.getters.prefInformationNotice,
        callback: () => this.jumpTo("/prefinformation"),
      });

      items.push({
        path: "/information",
        label: "お知らせ",
        key: "1",
        notice: this.$store.getters.informationNotice,
        callback: () => this.jumpTo("/information"),
      });

      items.push({
        path: "/product",
        label: "作業・生産記録",
        key: "2",
        notice: false,
        callback: () => this.jumpTo("/product"),
      });

      items.push({
        path: "/graph/product",
        label: "グラフ",
        key: "3",
        notice: false,
        callback: () => this.jumpTo("/graph/product"),
      });

      items.push({
        path: "/predictionTool",
        label: "予測ツール",
        key: "5",
        notice: false,
        callback: () => this.jumpTo("/predictionTool"),
      });

      return items;
    },
    getShowRecordMenu() {
      let isShow = false;
      let paths = [
        "/product",
        "/worklog",
        "/unloading",
        "/shipping",
        "/seaWater",
      ];

      for (let path of paths) {
        if (this.$router.currentRoute.path.startsWith(path)) {
          isShow = true;
        }
      }
      return isShow;
    },
    getShowGraphMenu() {
      let isShow = false;
      let paths = [
        "/graph/product",
        "/graph/umilog",
        "/deviceMap",
        "/externalLink",
      ];

      for (let path of paths) {
        if (this.$router.currentRoute.path.startsWith(path)) {
          isShow = true;
        }
      }
      return isShow;
    },
    jumpTo(url) {
      this.$router.push(url, () => {});
    },
    /**
     * 作業記録設定画面を呼び出す
     */
    worklog() {
      this.$router.push("/worklog", () => {});
    },
    /**
     * 水揚げ設定画面を呼び出す
     */
    unloading() {
      this.$router.push("/unloading", () => {});
    },
    /**
     * 加工・出荷設定画面を呼び出す
     */
    shipping() {
      this.$router.push("/shipping", () => {});
    },
    /**
     * 使用海水設定画面を呼び出す
     */
    seaWater() {
      this.$router.push("/seaWater", () => {});
    },
    /**
     * 生産情報グラフを呼び出す
     */
    graph() {
      this.$router.push("/graph/product", () => {});
    },
    /**
     * うみロググラフを呼び出す
     */
    umilogGraph() {
      this.$router.push("/graph/umilog", () => {});
    },
    /**
     * 現在水温の地図表示を呼び出す
     */
    deviceMap() {
      this.$router.push("/deviceMap", () => {});
      },
    /**
     * 現在水温の地図表示を呼び出す
     */
     externalLink() {
      this.$router.push("/externalLink", () => {});
      },
  },
};
</script>

<style>
.tab-item {
  width: 200px;
}
.tab-active {
  color: white !important;
  background-color: rgb(153, 171, 217);
  margin-top: 4px;
  margin-bottom: 4px;
}

.notice {
  height: 1.5rem;
  width: 1.5rem;
  line-height: 1.5rem;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  background-color: red;
  position: relative;
  top: -0.5em;
  display: inline-block;
}
</style>
